module.exports = __webpack_public_path__ + "img/logo-white.185ffc75.png";